<template>
  <figure>
    <h3 class="subtitle is-5">Policy Set</h3>
    <ul>
      <li v-for="a in agg" :key="a.key">
        <b-radio v-model="selectedPolicy" type="is-info is-light" name="aggPolicySet" :native-value="a.key">
          <b-taglist class="has-addons">
            <b-tag type="is-light has-text-info" size="is-medium">
              <font-awesome-icon icon="atom" class="mr-2"/>
              {{ a.key }}
            </b-tag>
            <b-tag type="is-light has-text-info" size="is-medium">{{ a.count.toLocaleString() }}</b-tag>
          </b-taglist>
        </b-radio>
      </li>
    </ul>
    <div v-if="selectedPolicy" class="buttons mt-4 is-centered">
      <b-button type="is-primary" @click="filter">
        Filter by policy
      </b-button>
    </div>
  </figure>
</template>

<script>
export default {
  emits: ['filter'],
  props: {
    agg: Array
  },
  data () {
    return {
      selectedPolicy: null
    }
  },
  methods: {
    filter () {
      this.$store.commit('filters/setPolicySet', this.selectedPolicy)
      this.$emit('filter')
    }
  }
}
</script>